export default [
  {
    title: 'مدیریت پیام ها',
    icon: 'bx bx-message-dots',
    children: [
      {
        title: 'پیام',
        route: { name: 'notificationList' },
        resource: 'NotificationManager',
        action: 'show',
      },
      {
        title: 'سگمنت سفارشی',
        route: { name: 'listSegment' },
        resource: 'SegmentManager',
        action: 'show',
      },

      {
        title: 'سگمنت پایه',
        route: { name: 'segmentbase' },
        resource: 'SegmentManager',
        action: 'show',
      },
      {
        title: 'گزارش سگمنت ها',
        route: { name: 'segmentReports' },
        resource: 'SegmentManager',
        action: 'show',
      },

      // {
      //   title: 'گزارش سگمنت',
      //   route: { name: 'reportSegment' },
      //   resource: 'TicketDepartmentManager',
      //   action: 'show',
      // },
    ],
  },
]
